import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icons/Icon';
import ExpandedRow from './ExpandedRow';
import DisplayErrorMessages from './DisplayErrorMessages';
import { formatImportDate } from '../../utils/dates';

const ImportEntryRow = ({ entry, type }) => {
  // if errored entry expanded by default
  const [isExpandedEntry, setIsExpandedEntry] = useState(!!entry.errors.length > 0);
  const isEntryErrors = entry.errors.length > 0;
  const entryErrors = entry.errors;
  const entryName = () => {
    if (type === 'note') {
      const date = entry.timestamp ? formatImportDate(entry.timestamp) : '(no date)';
      const title = entry.title ? entry.title : 'Untitled note';
      return `${date} ${title}`;
    }
    if (type === 'visit') {
      const date = entry.date ? formatImportDate(entry.date) : '(no date)';
      const purpose = entry.purpose ? entry.purpose : 'Untitled visit';
      return `${date} ${purpose}`;
    }
    if (type === 'contact') {
      return entry.name || 'Untitled contact';
    }
    return entry.name || 'Untitled site';
  };
  // styles when entry expanded or not
  const entryClassName = isExpandedEntry ? 'border border-vamos-blue-gray rounded-md overflow-hidden' : 'border-0 rounded-md overflow-hidden';
  // entry header style when entry has errors or not
  const entryHeaderColor = `${isEntryErrors ? 'bg-vamos-light-gray' : 'bg-vamos-green3'} px-6.5 py-2.5`;
  return (
    <div className={entryClassName}>
      <div className={entryHeaderColor} data-testid="import-entry-color">
        <button
          type="button"
          className="flex justify-between min-h-8 items-start gap-x-3 w-full"
          aria-label="show entry"
          onClick={() => {
            setIsExpandedEntry(!isExpandedEntry);
          }}
          data-testid="show-import-entry"
        >
          <div className="flex-auto font-bold whitespace-nowrap text-left">
            {entryName()}
          </div>
          <div className="flex gap-y-4 pl-4">
            {isEntryErrors && <DisplayErrorMessages entryErrors={entryErrors} />}
            <div
              className="flex-shrink-0 justify-center items-center h-6 w-6"
            >
              <Icon name="collapse" className={`cursor-pointer ${isExpandedEntry ? 'rotate-180' : ''}`} />
            </div>
          </div>
        </button>
      </div>
      {isExpandedEntry && (
        <ExpandedRow entry={entry} type={type} />
      )}
    </div>
  );
};

ImportEntryRow.propTypes = {
  entry: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
};

export default ImportEntryRow;

